// extracted by mini-css-extract-plugin
export default {"totalizerValueWrapper":"Tqv-C5H4Tt18yxhawLAyJQ=="};